import { exportExcel } from "@api/stores/purchaseInvoiceItemReport/exportExcel/api";
import { exportPDF } from "@api/stores/purchaseInvoiceItemReport/exportPDF/api";
import { exportSinglePDF } from "@api/stores/purchaseInvoiceItemReport/exportSinglePDF/api";
import { stats } from "@api/stores/purchaseInvoiceItemReport/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IPurchaseInvoiceItemReportGetAllParams,
  IPurchaseInvoiceItemReportResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoiceItemReportResponse>>,
  IPathBaseParam,
  IPaginationParams & IPurchaseInvoiceItemReportGetAllParams
>("stores.purchaseInvoiceItemReport");

export const purchaseInvoiceItemReport = {
  ...getAllApis,
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
